/* eslint-disable */
import React, { useEffect, useState } from "react"
import { createPortal } from "react-dom"
import TeamMemberDropdown from "../../../components/molecules/TeamMemberDropdown"
import TabviewControllersContainer from "../../../components/layouts/containers/TabviewControllersContainer.container"
import { setLastIndividualTeamMemberReport } from "../../../services/report.service"
import { useSession } from "../../../hooks/auth/useSession.hook"
import UnifiedDatePicker from "../../../components/compounds/UnifiedDatePicker.compound"
import ResetButton from "../../generalReport/controllers/components/ResetButton"
import { TeamMemberProjectRoleContainer } from "../../../components/layouts/containers/TeamMemberProjectRoleContainer.container"
import { Role } from "../../../consts/roles.consts"
import useScreenDimensionsContext from "../../../hooks/contextConsumers/useScreenDimensionsContext.hook"

const IndividualReportControls = ({
  teamMember,
  setTeamMember,
  period,
  setPeriod,
  dateRange,
  setDateRange,
  onReset,
  loadingTasks,
  loadingSummary,
}) => {
  const [pickerContainer, setPickerContainer] = useState(null)
  const auth = useSession()

  useEffect(() => {
    const container = document.querySelector(
      "#individual-report .p-tabview-nav"
    )
    if (container) {
      setPickerContainer(container)
    }
  }, [])

  useEffect(() => {
    if (teamMember && auth.user.isAdmin()) {
      settingLastTeamMemberReport(teamMember.id)
    }
  }, [teamMember])

  const settingLastTeamMemberReport = async (teamMemberId = null) => {
    await setLastIndividualTeamMemberReport(teamMemberId || teamMember?.id)
  }

  const { screenWidth } = useScreenDimensionsContext()
  const isMobile = screenWidth < 479

  const content = (
    <TabviewControllersContainer className="individual-report-controls">
      <TeamMemberProjectRoleContainer
        roles={[Role.ADMIN, Role.ADMIN_WITHOUT_REPORT]}
      >
        <TeamMemberDropdown
          optionValue="id"
          selectedTeamMember={teamMember?.id}
          setSelectedTeamMember={setTeamMember}
        />
      </TeamMemberProjectRoleContainer>
      <UnifiedDatePicker
        dateRange={dateRange}
        setDateRange={setDateRange}
        period={period}
        setPeriod={setPeriod}
        disabledChevrons={loadingTasks || loadingSummary}
      />
      <ResetButton onClick={onReset} />
    </TabviewControllersContainer>
  )
  if (isMobile) return content
  if (!pickerContainer) return null
  return createPortal(content, pickerContainer)
}

export default IndividualReportControls
